import gql from "graphql-tag";

export default gql`
	mutation gqlExchangeIdToken($issuerId: String!, $idToken: String!) {
		exchangeToken(issuerId: $issuerId, idToken: $idToken) {
			token
			refreshToken
			customer {
				customerID
			}
		}
	}
`;
